import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M15 16C14.1478 16 13.7026 15.0145 14.2168 14.3775L14.2929 14.2929L16.584 12.0007C15.3147 10.7976 13.3017 10 11 10C7.08172 10 4 12.3113 4 15C4 15.5523 3.55228 16 3 16C2.44772 16 2 15.5523 2 15C2 11.0613 6.08172 8.00001 11 8.00001C13.8067 8.00001 16.341 8.99694 17.9997 10.585L20.2929 8.2929C20.8955 7.69032 21.9072 8.07234 21.994 8.88637L22 9.00001V15C22 15.5128 21.614 15.9355 21.1166 15.9933L21 16H15Z" />,
  'Redo'
);
